import { render, staticRenderFns } from "./LockedUsersManagement.vue?vue&type=template&id=940ff2f4"
import script from "./LockedUsersManagement.vue?vue&type=script&lang=js"
export * from "./LockedUsersManagement.vue?vue&type=script&lang=js"
import style0 from "./LockedUsersManagement.vue?vue&type=style&index=0&id=940ff2f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports